import { usePostFrontRichiesteIdValida } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type EsitoValidazioneRichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/esitoValidazioneRichiestaDTO.ts';
import { getNetworkErrorMessage } from '@framework/auth/http/errors/getNetworkErrorMessage.ts';
import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook che gestisce la validazione della richiesta.
 */
export function useSubmissionValidation(submissionId: string) {
  const { t } = useTranslation();
  const validateMutation = usePostFrontRichiesteIdValida();
  const [result, setResult] = useState<EsitoValidazioneRichiestaDTO | null>(
    null,
  );

  // Reset del risultato di validazione quando cambia la submissionId
  useEffect(() => {
    setResult(null);
  }, [submissionId]);

  const validate = useCallback(async () => {
    // Reset del risultato precedente prima di avviare una nuova validazione
    setResult(null);
    try {
      const result = await validateMutation.mutateAsync({ id: submissionId });
      setResult(result);
    } catch (e: unknown) {
      console.error('[useSubmissionValidation] Validation error', { error: e });
      message.error(
        getNetworkErrorMessage(
          e,
          t(
            'form.errore-durante-validazione',
            'Si è verificato un errore durante la validazione',
          ),
        ),
      );
    }
  }, [submissionId, validateMutation, t]);

  return { validate, result, isLoading: validateMutation.isLoading };
}
